'use client'

import { useTranslations } from 'next-intl'
import type { PropsWithChildren } from 'react'

import { usePathname, useRouter } from '@/shared/i18n'
import { Slot } from '@/shared/lib'
import { SegmentedControl } from '@/shared/ui'
import { MobileHeader } from '@/widgets/common'

type Props = {
  title: string
  userType: 'guest' | 'host'
  type: 'event' | 'partnership' | 'article'
}

export const MobileCampaignLayout = ({
  title,
  userType,
  type,
  children,
}: PropsWithChildren<Props>) => {
  const router = useRouter()
  const pathname = usePathname()

  const t = useTranslations('events_partnerships')

  const handleTypeChange = (value: string) => {
    if (pathname?.includes(value)) {
      return
    }

    router.replace(`/${userType}/campaign/${value}`)
  }

  return (
    <>
      <MobileHeader.Root>
        <Slot name="left">
          <MobileHeader.Back />
        </Slot>
        <Slot name="title">{title}</Slot>
      </MobileHeader.Root>
      <main className="flex h-0 grow flex-col overflow-y-auto">
        {type !== 'article' && (
          <div className="w-full px-4">
            <SegmentedControl.Root
              type="single"
              variant="padded"
              shape="pill"
              size="medium"
              value={type}
              onValueChange={handleTypeChange}
              className="my-6 p-1"
            >
              <SegmentedControl.Item value="event" id="event" className="h-8.5">
                {t('tab.event')}
              </SegmentedControl.Item>
              <SegmentedControl.Item
                value="partnership"
                id="partnership"
                className="h-8.5"
              >
                {t('tab.partnership')}
              </SegmentedControl.Item>
            </SegmentedControl.Root>
          </div>
        )}
        {children}
      </main>
    </>
  )
}
